module.exports = __webpack_public_path__ + "static/media/github-alt.91051d68.svg";